var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-label"},[_c('switch-field',{staticClass:"switch-field",attrs:{"readonly":true,"value":_vm.value,"name":_vm.name,"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }